<template>
  <b-row>
    <b-col cols="12">
      <pixels-table :key="$route.fullPath" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import PixelsTable from './PixelsTable.vue'

export default {
  components: {
    BRow,
    BCol,
    PixelsTable,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
